import { combineReducers } from 'redux'
import { StatisticsTypes } from '../../action_types'

import { handleRequest, initialRequestState } from './helpers'

function getSubmissionsSummary(state = initialRequestState(), action) {
  return handleRequest(
    StatisticsTypes.GET_SUBMISSIONS_SUMMARY_REQUEST,
    StatisticsTypes.GET_SUBMISSIONS_SUMMARY_SUCCESS,
    StatisticsTypes.GET_SUBMISSIONS_SUMMARY_FAIL,
    state,
    action
  )
}

function getStatisticsByDay(state = initialRequestState(), action) {
  return handleRequest(
    StatisticsTypes.GET_STATISTICS_BY_DAY_REQUEST,
    StatisticsTypes.GET_STATISTICS_BY_DAY_SUCCESS,
    StatisticsTypes.GET_STATISTICS_BY_DAY_FAIL,
    state,
    action
  )
}

function getStatisticsByWeek(state = initialRequestState(), action) {
  return handleRequest(
    StatisticsTypes.GET_STATISTICS_BY_WEEK_REQUEST,
    StatisticsTypes.GET_STATISTICS_BY_WEEK_SUCCESS,
    StatisticsTypes.GET_STATISTICS_BY_WEEK_FAIL,
    state,
    action
  )
}

function getStatisticsByMonth(state = initialRequestState(), action) {
  return handleRequest(
    StatisticsTypes.GET_STATISTICS_BY_MONTH_REQUEST,
    StatisticsTypes.GET_STATISTICS_BY_MONTH_SUCCESS,
    StatisticsTypes.GET_STATISTICS_BY_MONTH_FAIL,
    state,
    action
  )
}

function getStatisticsWorkSummary(state = initialRequestState(), action) {
  return handleRequest(
    StatisticsTypes.GET_STATISTICS_WORK_SUMMARY_REQUEST,
    StatisticsTypes.GET_STATISTICS_WORK_SUMMARY_SUCCESS,
    StatisticsTypes.GET_STATISTICS_WORK_SUMMARY_FAIL,
    state,
    action
  )
}

function getStatisticsByDate(state = initialRequestState(), action) {
  return handleRequest(
    StatisticsTypes.GET_STATISTICS_BY_DATE_REQUEST,
    StatisticsTypes.GET_STATISTICS_BY_DATE_SUCCESS,
    StatisticsTypes.GET_STATISTICS_BY_DATE_FAIL,
    state,
    action
  )
}

function getUserTaskHistoryDashboard(state = initialRequestState(), action) {
  return handleRequest(
    StatisticsTypes.GET_USER_TASK_HISTORY_DASHBOARD_REQUEST,
    StatisticsTypes.GET_USER_TASK_HISTORY_DASHBOARD_SUCCESS,
    StatisticsTypes.GET_USER_TASK_HISTORY_DASHBOARD_FAIL,
    state,
    action
  )
}

function getCollabTaskAccuracyDashboard(state = initialRequestState(), action) {
  return handleRequest(
    StatisticsTypes.GET_COLLAB_TASK_ACCURACY_DASHBOARD_REQUEST,
    StatisticsTypes.GET_COLLAB_TASK_ACCURACY_DASHBOARD_SUCCESS,
    StatisticsTypes.GET_COLLAB_TASK_ACCURACY_DASHBOARD_FAIL,
    state,
    action
  )
}

function getVerifierTaskAccuracyDashboard(state = initialRequestState(), action) {
  return handleRequest(
    StatisticsTypes.GET_VERIFIER_TASK_ACCURACY_DASHBOARD_REQUEST,
    StatisticsTypes.GET_VERIFIER_TASK_ACCURACY_DASHBOARD_SUCCESS,
    StatisticsTypes.GET_VERIFIER_TASK_ACCURACY_DASHBOARD_FAIL,
    state,
    action
  )
}

function getDueWorkSummary(state = initialRequestState(), action) {
  return handleRequest(
    StatisticsTypes.GET_DUE_WORK_SUMMARY_REQUEST,
    StatisticsTypes.GET_DUE_WORK_SUMMARY_SUCCESS,
    StatisticsTypes.GET_DUE_WORK_SUMMARY_FAIL,
    state,
    action
  )
}

export default combineReducers({
  getSubmissionsSummary,
  getStatisticsByDay,
  getStatisticsByWeek,
  getStatisticsByMonth,
  getStatisticsWorkSummary,
  getCollabTaskAccuracyDashboard,
  getUserTaskHistoryDashboard,
  getStatisticsByDate,
  getVerifierTaskAccuracyDashboard,
  getDueWorkSummary
})
